(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    

  const baseURL = "https://coastalcarats.gemist.co/";

  window.onload = function() {

// Get the current URL of the parent page
    var url = window.location.href;

// Get the query string from the URL
    var queryString = url.split('?')[1];

// Create the iframe URL with the query string
    var iframeUrl = baseURL + "designer/necklaces?" + queryString;

// Set the iframe's source URL
    var iframe = document.getElementById("designer-iframe");

    iframe.src = iframeUrl;
  };

  window.addEventListener("message", function(event) {

    const designerIframe = document.getElementById("designer-iframe");

    if (event.data) {
      try {
        const message = JSON.parse(event.data);
        switch (message.type) {

case "buy": {
  var rawRingId =
    message.ring && message.ring.variantId !== undefined
      ? message.ring.variantId
      : message.product &&
        message.product.Shopify &&
        message.product.Shopify.productVariant;

  var id;
  if (rawRingId === undefined || rawRingId === null) {
    id = undefined;
  } else if (typeof rawRingId === "number") {
    id = String(rawRingId);
  } else if (
    typeof rawRingId === "string" &&
    rawRingId.indexOf("/") !== -1
  ) {
    id = rawRingId.split("/").slice(-1)[0];
  } else {
    id = String(rawRingId);
  }

  var size = message.size;
  var ringItems = [];

  var product = {
    id: id,
    quantity: 1,
    properties: {
      Size: size,
      _gemist__ring: true
    }
  };

  var ring = message.ring || {};
  Object.keys(ring).forEach(function(key) {
    if (key === "variantId") return;
    var value = ring[key];
    if (value === undefined || value === null || value === "") return;
    var propName = key.charAt(0).toUpperCase() + key.slice(1);
    product.properties[propName] = value;
  });
  if (typeof message.image === "string" && message.image) product.properties._image_product = message.image;

  if (message.engravingText != "") {
    var engraving = {
      id: "",
      quantity: 1,
      properties: {
        Text: message.engravingText.toUpperCase(),
        Font: message.engravingFont.toUpperCase(),
        _gemist__ring: true
      }
    };

    ringItems.push(engraving);
  }

  ringItems.push(product);

  if (!id) {
    designerIframe.contentWindow.postMessage(
      { type: "cart", status: "error", message: "No variant id" },
      "*"
    );
    break;
  }

  function isSoldOutError(data) {
    if (!data) return false;

    var text = [data.message, data.description]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return data.status === 422 && text.indexOf("already sold out") !== -1;
  }

  function wait(ms) {
    return new Promise(function(resolve) {
      setTimeout(resolve, ms);
    });
  }

  function goToCartOrOpenDrawer() {
    if (
      window.cartDrawer &&
      typeof window.cartDrawer.refresh === "function" &&
      typeof window.cartDrawer.open === "function"
    ) {
      window.cartDrawer.refresh()
        .then(function() {
          window.cartDrawer.open();
        })
        .catch(function(error) {
          console.error("goToCartOrOpenDrawer: refresh failed, falling back to redirect", error);
          window.location.href = window.Shopify.routes.root + "cart";
        });
    } else {
      window.location.href = window.Shopify.routes.root + "cart";
    }
  }

  function addRingToCart(attempt) {
    var MAX_ATTEMPTS = 3; // 1 intento inicial + 2 reintentos

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: ringItems })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      })
      .then(function(result) {
        console.log("cart/add result", result, "attempt", attempt);

        if (!result.ok) {
          if (isSoldOutError(result.data) && attempt < MAX_ATTEMPTS) {
            console.warn(
              "Sold out error detected. Retrying in 3 seconds...",
              "attempt",
              attempt
            );

            return wait(3000).then(function() {
              return addRingToCart(attempt + 1);
            });
          }

          throw new Error(
            result.data.description ||
              result.data.message ||
              "Add to cart failed"
          );
        }

        return result;
      });
  }

  addRingToCart(1)
    .then(function(result) {
      if (message.diamond && message.diamond.variantId !== undefined) {
        var diamondVariantId = message.diamond.variantId;
        if (typeof diamondVariantId === "number")
          diamondVariantId = String(diamondVariantId);
        else if (typeof diamondVariantId === "string" && diamondVariantId.indexOf("/") !== -1)
          diamondVariantId = diamondVariantId.split("/").slice(-1)[0];

        var diamond = { id: diamondVariantId, quantity: 1 };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items: [diamond] })
        })
          .then(function(res) {
            return res.json().then(function(d) { return { ok: res.ok, data: d }; });
          })
          .then(function(diamondResult) {
            if (diamondResult.ok) {
              designerIframe.contentWindow.postMessage(
                { type: "cart", status: "added" },
                "*"
              );
              goToCartOrOpenDrawer();
            } else {
              var msg = (diamondResult.data && diamondResult.data.description)
                ? diamondResult.data.description
                : (diamondResult.data && diamondResult.data.message)
                  ? diamondResult.data.message
                  : "Diamond add failed";
              designerIframe.contentWindow.postMessage(
                { type: "cart", status: "error", message: msg },
                "*"
              );
            }
          })
          .catch(function(error) {
            console.error("Error al agregar el diamante:", error);
            designerIframe.contentWindow.postMessage(
              { type: "cart", status: "error", message: String(error && error.message ? error.message : error) },
              "*"
            );
          });
      } else {
        designerIframe.contentWindow.postMessage(
          { type: "cart", status: "added" },
          "*"
        );
        goToCartOrOpenDrawer();
      }
    })
    .catch(function(error) {
      console.error("Error al agregar el anillo:", error);
      designerIframe.contentWindow.postMessage(
        {
          type: "cart",
          status: "error",
          message: String(error && error.message ? error.message : error)
        },
        "*"
      );
    });

  break;
}
          case 'favorite':
                        var {id} = message.product;
                    
                        fetch(baseURL + 'api/products/' + id + '/shmetadata')
                        .then(response => response.json())
                        .then(data => {
                          var {productId, handle} = data;
                          
                          // create element to save
                          var elementToSave = document.createElement('div');
                          elementToSave.dataset.id = productId.split('/').slice(-1)[0];
                          elementToSave.dataset.handle = handle;
                          
                          // use the saveWishlist function that we made available from theme.js
                          saveWishlist($(elementToSave));
                        })
                        .catch((error) => {
							console.error('Error:', error);
						});
                        break;
                    case 'updateParams':
                        // Get the parameter names from the message
                        var paramNames = message.paramNames;
                        var currentURL = new URL(window.location.href);
                  
                        // Loop through the parameter names
                        paramNames.forEach(function(paramName) {
                          // Retrieve the corresponding value from the message
                          var paramValue = message[paramName];
                  
                          // Modify the query parameter of the parent URL with the value
                          if (paramValue !== undefined) {
                            currentURL.searchParams.set(paramName, paramValue);
                          }
                        });
                  
                        // Replace the parent URL with the modified URL
                        window.history.replaceState({}, "", currentURL.toString());
                        break;
                    case 'download':
                        const downloadHref = message.downloadHref;


                        
                        if (downloadHref) {
                          window.open(downloadHref, "_blank");
                        }
						break;
                    case 'copywindowlocation':
                        // Get the current window location
                        var windowLocation = window.location.href;
                        
                        // Use the Clipboard API to copy the window location to the clipboard
                        navigator.clipboard.writeText(windowLocation)
                          .then(function() {
                            console.log("Window location copied to clipboard successfully");
                          })
                          .catch(function(error) {
                            console.error("Failed to copy window location to clipboard:", error);
                          });
						break;
                     case 'sendemail':
                        let {emailContent, subject, recipient} = message;
                        const currentPageLink = window.location.href;
                        emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);                   

                        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
                          subject
                        )}&body=${encodeURIComponent(emailContent)}`;

                        if (mailtoLink) {
                          window.open(mailtoLink, "_blank");
                        }
						break;
                    case "requestfullscreen":
                        void designerIframe.requestFullscreen();
                        break;
					default: 
						break;
        }
      } catch (e) { // console.log("Designer error", e);
      }
    }
  }, false);


// This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height,
// then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function() {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(".designer-iframe-container");
    const designerIFrameElement = document.querySelector("#designer-iframe");

    const selectorsToObserve = [".site-header"];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 10);

      if (designerIFrameContainerElement !== null && designerIFrameElement !== null && totalHeight) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;

        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });


  } catch(e) { console.error(e); }
})();
})();
